import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layout components
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import SoftwareSolutions from "./pages/SoftwareSolutions";
import DigitalMarketing from "./pages/DigitalMarketing";
import Industries from "./pages/Industries";
import Contact from "./pages/Contact";
import WebAppDevelopment from "./pages/WebAppDevelopment";
import AIDataAutomation from "./pages/AIDataAutomation";
import SEOPerformanceMarketing from "./pages/SEOPerformanceMarketing";
import BrandingCreative from "./pages/BrandingCreative";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/software-solutions" element={<SoftwareSolutions />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/web-app-development" element={<WebAppDevelopment />} />
          <Route path="/services/ai-data-automation" element={<AIDataAutomation />} />
          <Route path="/services/seo-performance-marketing" element={<SEOPerformanceMarketing />} />
          <Route path="/services/branding-creative" element={<BrandingCreative />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;